<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-body p-15 p-sm-20 p-sm-25 p-lg-30">
      <div class="table-responsive mb-20">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Code d'envoi
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Status
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Etat
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Commentaire
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Date
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
              >
                Informations
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 pe-0"
              >
                Action par
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(detail, index) in detailsColis" :key="index">
              <th class="shadow-none lh-1 fw-bold ps-0">
                <b>{{ detail.parcel_code }}</b>
              </th>
              <td class="shadow-none lh-1 fw-medium">
                <span
                  v-if="
                    detail.status === 'IN_PROGRESS' &&
                    detail.status_second &&
                    detail.status_second !== null
                  "
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{
                    '--dynamic-bg': detail.statut.code_color,
                  }"
                >
                  {{ resolveStatuParcel(detail?.status_second) }}
                </span>
                <span
                  v-else
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{ '--dynamic-bg': detail?.statut?.code_color }"
                >
                  {{ detail?.statut?.s_name }}
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span
                  :class="`badge text-outline-${resolveUserStatusVariant(
                    detail.situation
                  )} rounded-pill fs-13`"
                  >{{ detail.situation }}</span
                >
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                <p>{{ detail.comment }}</p>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                {{ getDate(detail.created_at) }}
              </td>
              <td class="shadow-none lh-1 fw-medium pe-0">
                <ul>
                  <li v-if="detail.city_name">
                    <span class="text-nowrap"
                      ><b>Ville: </b> {{ detail.city_name }}</span
                    >
                  </li>
                  <li v-if="detail.data">
                    <span class="text-nowrap">{{ detail.data }}</span>
                  </li>
                  <li v-if="detail.livreur_name && detail.livreur_phone">
                    <span class="text-nowrap"
                      ><b>Livreur : </b>{{ detail.livreur_name }} <b>/</b>
                      {{ detail.livreur_phone }}
                    </span>
                  </li>
                  <li v-if="detail.datas && detail.datas.length !== 0">
                    <ul
                      v-for="(data, index) in detail.datas"
                      :key="index"
                      style="list-style-type: circle"
                    >
                      <li>
                        {{ data.data }} (<b>{{ getDate(data.created_at) }}</b
                        >)
                      </li>
                    </ul>
                  </li>
                </ul>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                {{ detail.history_by_name }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <hr />
      <h6 class="card-title fw-bold mb-20">Historique d'appel</h6>

      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Code d'envoi
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Appelé par
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Date
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in detailsCalls" :key="index">
              <th class="shadow-none lh-1 fw-bold ps-0">
                <b>{{ item.parcel_code }}</b>
              </th>
              <td class="shadow-none lh-1 fw-medium">
                <b>Livreur:</b> {{ item.user_name }}<br /><b>Téléphone:</b
                >{{ item.phone }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-body-tertiary">
                {{ getDate(item.created_at) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, reactive, onMounted } from "vue";
import moment from "moment";
import api from "@/utils/axios";
import { useAppToast } from "@/composables/useAppToast";
import { useGlobalStore } from "@/stores/global";
import { useAuthStore } from "@/stores/auth";
import { watch } from "vue";
export default {
  name: "HistoryColis",

  props: {
    colisId: {
      type: Number,
      required: true,
    },

    isOpen: {
      type: Boolean,
    },
  },

  setup: (props) => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const detailsColis = ref([]);
    const detailsCalls = ref([]);

    const loading = ref(false);
    const globalStore = useGlobalStore();

    function getDate(value: string) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    async function getData() {
      loading.value = true;
      try {
        const res = await api.get(
          `/api/auth/client/get_Coli_Suivi/${props.colisId}`
        );
        detailsColis.value = res.data;
      } finally {
        loading.value = false;
      }
    }

    async function getDetailsCall() {
      try {
        const res = await api.get(
          `/api/auth/client/callsParcel/${props.colisId}`
        );
        detailsCalls.value = res.data.data;
      } catch (error) {
        console.error("Error fetching call details:", error);
      }
    }

    onMounted(() => {
      console.log("isOpen:", props.isOpen, props.colisId);
      if (props.isOpen) {
        getData();
        getDetailsCall();
      }
    });

    watch(
  [() => props.colisId, () => props.isOpen],
  ([id, open]) => {
    if (open && id) {
      console.log("Loading history for colisId:", id);
      getData();
      getDetailsCall();
    }
  },
  { immediate: true }
);

    function resolveUserStatusVariant(status) {
      if (status === "PICKED_UP") return "warning";
      if (status === "DELIVERED") return "success";
      if (status === "PAID") return "info";
      if (status === "NOT_PAID") return "danger";
      if (status === "Payé") return "info";
      if (status === "Non Payé") return "warning";
      if (status === "Facturé") return "info";
      return "primary";
    }
    function resolveStatuParcel(status) {
      if (status === "POSTPONED") return "Reporté";
      if (status === "DELIVERED") return "Livré";
      if (status === "PAID") return "Payé";
      if (status === "NOT_PAID") return "Non Payé";
      if (status === "Payé") return "Payé";
      if (status === "CANCELED") return "Annulé";
      if (status === "UNREACHABLE") return "Injoignable";
      if (status === "POSTPONED") return "Reporté";
      if (status === "RETURNED") return "Retourné";
      if (status === "RECEIVED") return "Reçu";
      if (status === "OUT_OF_AREA") return "Hors-zone";
      if (status === "NOANSWER") return "Pas de réponse + SMS";
      if (status === "SENTED") return "Expédié";
      if (status === "REFUSE") return "Refusé";
      if (status === "ONV") return "En Voyage";
      if (status === "INT") return "Client intéréssé";
      if (status === "POSTPONED_TEAM") return "Reporté ( SUIVI )";
      if (status === "CANCELED_TEAM") return "Annulé ( SUIVI )";
      if (status === "VOICEMAIL_TEAM") return "Boite Vocal ( SUIVI )";
      if (status === "EN") return "Erreur Numéro";
      return status;
    }
    return {
      detailsColis,
      detailsCalls,
      loading,
      globalStore,
      getDate,
      resolveStatuParcel,
      resolveUserStatusVariant,
    };
  },
};
</script>